import { getRequest, postRequest } from './request';

export const getJobProfileSettings = async () => {
  const data = await getRequest({ url: '/settings-api/job-profile-settings' });

  return {
    fields: data.fields || [],
    levels: data.levels || [],
  };
};

export const saveJobProfileSettings = async (payload) => {
  const data = await postRequest({
    url: '/settings-api/job-profile-settings',
    body: {
      fields: payload.fields,
      levels: payload.levels,
    },
  });

  if (!data.success) {
    throw new Error('Job profile settings update failed');
  }

  return {
    success: true,
    fields: data.fields || [],
    levels: data.levels || [],
  };
};
